"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _joi = require('@hookform/resolvers/joi');
var _joi3 = require('shared/services/validation/joi'); var _joi4 = _interopRequireDefault(_joi3);

 const MIN_MESSAGE_DELAY_MS = 1000; exports.MIN_MESSAGE_DELAY_MS = MIN_MESSAGE_DELAY_MS
// Rev 27 P3: as fast as the sender goes (about one message a second).
 const DEFAULT_MESSAGE_DELAY_MS = 1000; exports.DEFAULT_MESSAGE_DELAY_MS = DEFAULT_MESSAGE_DELAY_MS
 const MAX_MESSAGE_DELAY_MS = 30000; exports.MAX_MESSAGE_DELAY_MS = MAX_MESSAGE_DELAY_MS

/* The backend limits a campaign's rendered text by type: an insecure SMS
 * travels as SMS, while a secure message is read on the secure page. */
 const MAX_SMS_BROADCAST_MESSAGE_LENGTH = 1600; exports.MAX_SMS_BROADCAST_MESSAGE_LENGTH = MAX_SMS_BROADCAST_MESSAGE_LENGTH
 const MAX_SECURE_BROADCAST_MESSAGE_LENGTH = 40000; exports.MAX_SECURE_BROADCAST_MESSAGE_LENGTH = MAX_SECURE_BROADCAST_MESSAGE_LENGTH
/** @deprecated The limit depends on the campaign type; use broadcastMessageLimit. */
 const MAX_BROADCAST_MESSAGE_LENGTH = exports.MAX_SMS_BROADCAST_MESSAGE_LENGTH; exports.MAX_BROADCAST_MESSAGE_LENGTH = MAX_BROADCAST_MESSAGE_LENGTH

var MessageType; (function (MessageType) {
  const SecureSMS = 'secure_sms'; MessageType["SecureSMS"] = SecureSMS;
  const InsecureSMS = 'insecure_sms'; MessageType["InsecureSMS"] = InsecureSMS;
})(MessageType || (exports.MessageType = MessageType = {}));

 const broadcastMessageLimit = (messageType) =>
  messageType === MessageType.InsecureSMS
    ? exports.MAX_SMS_BROADCAST_MESSAGE_LENGTH
    : exports.MAX_SECURE_BROADCAST_MESSAGE_LENGTH; exports.broadcastMessageLimit = broadcastMessageLimit














const detailsKeys = {
  name: _joi3.requiredString.call(void 0, ).max(100).messages(_joi3.makeStrErrors.call(void 0, 'Campaign name')),
  teamKey: _joi3.requiredString.call(void 0, ).messages(_joi3.makeStrErrors.call(void 0, 'Team')),
  senderKey: _joi3.requiredString.call(void 0, ).messages(_joi3.makeStrErrors.call(void 0, 'Sender')),
  messageType: _joi3.requiredString.call(void 0, ),
  messageDelay: _joi4.default.number()
    .min(exports.MIN_MESSAGE_DELAY_MS)
    .max(exports.MAX_MESSAGE_DELAY_MS),
}

 const campaignDetailsResolver = _joi.joiResolver.call(void 0, _joi4.default.object(detailsKeys)); exports.campaignDetailsResolver = campaignDetailsResolver

const schema = _joi4.default.object({
  ...detailsKeys,
  messageTemplate: _joi4.default.when('messageType', {
    is: MessageType.InsecureSMS,
    then: _joi3.requiredString.call(void 0, )
      .max(exports.MAX_SMS_BROADCAST_MESSAGE_LENGTH)
      .messages(_joi3.makeStrErrors.call(void 0, 'Message')),
    otherwise: _joi3.requiredString.call(void 0, )
      .max(exports.MAX_SECURE_BROADCAST_MESSAGE_LENGTH)
      .messages(_joi3.makeStrErrors.call(void 0, 'Message')),
  }),
})

 const campaignResolver = _joi.joiResolver.call(void 0, schema); exports.campaignResolver = campaignResolver
